import { Construction } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { EmptyState } from '@/ui/primitives'
import { PageHeader } from '@/ui/page'

const TITLES: Record<string, string> = {
  staking: 'Staking',
  swap: 'Swap',
  legion: 'Crystal Army',
  governance: 'Governance Portal',
  education: 'Education',
  gitbook: 'GitBook',
}

/** A real route for planned menu destinations, rather than a dead link. */
export function ComingSoon() {
  const slug = useLocation().pathname.split('/').at(-1) ?? ''
  const title = TITLES[slug] ?? 'This feature'

  return (
    <div className="space-y-8">
      <PageHeader icon={Construction} title={title} subtitle="CrystalDEX" />
      <div className="surface-glass rounded-[18px] ring-1 ring-line">
        <EmptyState
          icon={<Construction className="size-7 text-accent" aria-hidden />}
          title="Coming soon"
          description={`${title} is being prepared for CrystalDEX.`}
        />
      </div>
    </div>
  )
}
